<template lang="html">
  <div class="card-cont-recurso col-12" >
    <div class="card-recurso">
      <!-- <router-link :to="$t('enlaces.recursos')+'/'+recurso.IdNoticia"></router-link> -->
      <label class="lbl-date-recurso">{{new Date(data.FechaPublicacion).toLocaleDateString('en-GB')}}</label>
      <label class="lbl-title-recurso">{{data.Titulo}}</label>
      <label class="lbl-body-recurso">{{data.Entradilla}}</label>
      <div class="hl-cont-recurso">
        <arrow-link class="arrow-link" :text="'VER MÁS'" :to="$t('enlaces.recursos')+'/'+data.IdNoticia" :external="false" :blank="false">
        </arrow-link>  
      </div>

    </div>
  </div>
</template>

<script lang="js">
  
  import arrowLink from '@/components/parts/icons/arrow-link';

  export default  {
    name: 'recurso-el',
    props :['data'],
    components : {
      'arrow-link': arrowLink,
    },
    methods : {
      parseISOString: function(s){
        var b = s.split(/\D+/);
        return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
      }
    },
    filters: {
    }
  }
</script>

<style scoped lang="scss">

  .card-cont-recurso{
    max-height: 220px;
    padding: 15px !important;
    min-width: 250px;
  }

  .card-recurso{
    height: 100%;
    width: 100%;
    margin: 14px 15px 28px 15px;;
    // background: #F0ECE8;
    border-bottom: 2px solid #F0ECE8 !important;

    a{
      position: absolute;
      width: 95%;
      height: 95%;
    }

    .lbl-date-recurso{
      height: 25px;
      width: 100%;
      float: left;
      text-align: left;
      margin-left: 18px;
      margin-top: 0px;
      color: #ff5700;
    }

    .lbl-title-recurso{
      height: 25px;
      width: 95%;
      float: left;
      text-align: left;
      margin-left: 18px;
      font-weight: 600;
      font-size: 24px;
      display:inline-block;
      white-space: nowrap; 
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .lbl-body-recurso{
      // height: 25px;
      max-height: 74px;
      width: 95%;
      float: left;
      text-align: left;
      margin-left: 18px;
      margin-top: 13px;
      font-size: 18px;
      display:inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .hl-cont-recurso{
      height:30px;
      float:left;
      margin-left: 18px;
      margin-top: 5px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/views/noticias/recurso-el.vue